import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { PrimaryButton } from '@/components/PrimaryButton';
import { Timer } from 'lucide-react';

export const Splash = () => {
  const navigate = useNavigate();
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden px-6">
      <div className="ns-bg-grain" />
      <div className="pointer-events-none absolute -top-40 h-[420px] w-[420px] rounded-full bg-[#38BDF8]/20 blur-[120px]" />
      <div className="pointer-events-none absolute bottom-0 right-0 h-[360px] w-[360px] rounded-full bg-[#EF4444]/20 blur-[120px]" />

      <motion.div
        initial={{ scale: 0.6, opacity: 0, rotate: -20 }}
        animate={{ scale: 1, opacity: 1, rotate: 0 }}
        transition={{ type: 'spring', stiffness: 200, damping: 16 }}
        className="relative mb-8"
      >
        <motion.div
          animate={{ scale: [1, 1.08, 1] }}
          transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
          className="flex h-28 w-28 items-center justify-center rounded-[32px]"
          style={{
            background: 'linear-gradient(135deg, #38BDF8, #0EA5E9)',
            boxShadow: '0 0 60px rgba(56,189,248,0.5)',
          }}
        >
          <Timer size={56} strokeWidth={2.5} className="text-[#0F172A]" />
        </motion.div>
      </motion.div>

      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.5 }}
        className="text-5xl font-extrabold tracking-[0.2em] text-white sm:text-6xl"
      >
        TABATA
      </motion.h1>
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.35, duration: 0.5 }}
        className="mt-3 text-base font-medium tracking-widest text-[#CBD5E1]"
      >
        Train with focus
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.55, duration: 0.5 }}
        className="mt-14 w-full max-w-xs"
      >
        <PrimaryButton
          className="w-full text-lg"
          onClick={() => navigate('/home')}
          data-testid="start-training-btn"
        >
          Start Training
        </PrimaryButton>
      </motion.div>
    </div>
  );
};

export default Splash;
